import { gql } from '@apollo/client';

export const CHECK_PRIZE_STATUS = gql`
	query CheckPrizeStatus {
		checkPrizeStatus {
			createdAt
			hidden
			id
			seen
			title
		}
	}
`;

export const MARK_AS_SEEN = gql`
	mutation UpdatePrize($input: PrizeUpdateInput!) {
		updatePrize(input: $input) {
			id
		}
	}
`;

export type CheckPrizeStatusQuery = {
	__typename?: 'Query';
	checkPrizeStatus?: Array<{
		createdAt: string;
		hidden: boolean;
		id: string;
		seen: boolean;
		title: string;
	} | null> | null;
};
